// extracted by mini-css-extract-plugin
export default {"wrapper":"selectedUser_wrapper__OGtiw","deleteChat":"selectedUser_deleteChat__kDT54","userContextBtn":"selectedUser_userContextBtn__iIwPs"};